module.exports = __webpack_public_path__ + "img/yen-sign.79c12a48.svg";